import { useQuery } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import GameScreenLayout from "@/components/GameScreenLayout"
import GeoPointsList from "@/components/geo/GeoPointsList"
import { normalizeGeoPoint } from "@/components/geo/geoPointHelpers"
import { usePlayerGpsState } from "@/hooks/usePlayerGpsState"
import { getBoosterShopPoints } from "@/api/gameApi"

export default function BoosterShopPage() {
  const [params] = useSearchParams()
  const highlightId = params.get("pointId")
  const gps = usePlayerGpsState()

  const q = useQuery({
    queryKey: ["booster-shops"],
    queryFn: getBoosterShopPoints,
  })

  const points = (q.data ?? []).map((p) =>
    normalizeGeoPoint({
      id: p.id,
      name: p.name,
      latitude: p.latitude,
      longitude: p.longitude,
      radiusMeters: p.radiusMeters,
      meta: p.priceByn ? `${p.priceByn} BYN` : undefined,
    })
  )

  return (
    <GameScreenLayout title="Магазины бустеров" backTo="/play/map">
      <p className="mb-2 text-xs text-guardians-muted">
        Покупка бустеров — через игровой магазин / redeem у точки (API как в приложении).
      </p>
      <GeoPointsList
        points={points}
        gps={gps}
        highlightId={highlightId}
        renderActions={({ inRange }) => (
          <span className="text-[10px] text-guardians-muted">
            {inRange ? "В радиусе" : "—"}
          </span>
        )}
      />
    </GameScreenLayout>
  )
}
